<template>
  <draggable
    v-model="items"
    @start="drag = true"
    @end="drag = false"
    @change="change"
  >
    <transition-group>
      <div
        v-for="(item, index) in items"
        :key="item.id"
        class="subtitle-1 grab"
      >
        {{ index + 1 }}. {{ item.title }}
      </div>
    </transition-group>
  </draggable>
</template>
<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: ["value"],
  data: () => ({
    items: [],
  }),
  watch: {
    value: {
      handler(val) {
        this.items = [...new Set(val)];
        this.addOrders();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addOrders() {
      this.items.forEach((i, index) => {
        i.order = index + 1;
      });
    },
    change() {
      this.addOrders();
      this.$emit("move", this.items);
    },
  },
};
</script>

<style>
.grab {
    cursor: grab;
}

.grab.sortable-chosen{
    cursor: grabbing;
}

.sortable-chosen {
color: #e57373 !important;
}
</style>